var _rect, _path, _ellipse, _g, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _line3, _line4, _line5, _path8, _ellipse2, _g2, _path9, _path10, _path11, _line6, _line7, _path12, _ellipse3, _g3, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootballPlayPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 101,
    viewBox: "0 0 622 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4031_1049)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 622,
    height: 101,
    rx: 20,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M528.689 113.108C503.761 112.863 483.75 92.456 483.995 67.5274C484.239 42.5986 504.646 22.5882 529.575 22.8328C554.504 23.0775 574.514 43.4845 574.27 68.4132C574.025 93.3419 553.618 113.352 528.689 113.108Z",
    stroke: "#512D9A",
    strokeWidth: 9.01396
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4031_1049",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 479,
    y: 18,
    width: 100,
    height: 100
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 529.136,
    cy: 67.9701,
    rx: 49.6464,
    ry: 49.6467,
    transform: "rotate(-179.438 529.136 67.9701)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4031_1049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.367 97.7162L509.386 94.5922L446.34 93.9735L495.041 59.316L497.709 57.4172L496.728 54.2932L478.816 -2.73296L526.825 32.8736L529.456 34.8243L532.124 32.9256L580.824 -1.73194L561.795 54.9317L560.753 58.0359L563.383 59.9866L611.394 95.5932L548.349 94.9746L547.306 98.0787L528.279 154.742L510.367 97.7162Z",
    stroke: "#512D9A",
    strokeWidth: 9.01396
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M543.55 63.437L537.894 80.2817L520.127 80.1074L514.802 63.1539L529.278 52.8511L543.55 63.437Z",
    fill: "#512D9A",
    stroke: "#512D9A",
    strokeWidth: 9.01396
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M545.27 109.499L564.019 96.2363L548.505 96.0841L545.27 109.499Z",
    fill: "#512D9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512.183 109.176L493.698 95.5478L509.212 95.7001L512.183 109.176Z",
    fill: "#512D9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M485.157 63.3977L493.537 42.0157L497.405 57.0403L485.157 63.3977Z",
    fill: "#512D9A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M574.001 64.2729L566.043 42.7305L561.881 57.6764L574.001 64.2729Z",
    fill: "#512D9A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M536.827 23.0882L520.144 28.0385L532.357 30.9652L536.827 23.0882Z",
    fill: "#512D9A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1.22918,
    x2: 14.4497,
    y2: -1.22918,
    transform: "matrix(-0.617001 -0.786963 0.78696 -0.617004 549.195 93.1533)",
    stroke: "#512D9A",
    strokeWidth: 2.45835
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1.22917,
    x2: 14.4497,
    y2: -1.22917,
    transform: "matrix(0.632325 -0.774703 -0.7747 -0.632329 508.574 92.751)",
    stroke: "#512D9A",
    strokeWidth: 2.45835
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1.22918,
    x2: 14.4497,
    y2: -1.22918,
    transform: "matrix(0.00981264 -0.999952 -0.999952 -0.00981274 528.156 52.3232)",
    stroke: "#512D9A",
    strokeWidth: 2.45835
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1.22917,
    x2: 14.4497,
    y2: -1.22917,
    transform: "matrix(-0.939515 -0.342507 -0.342504 0.939516 511.125 63.4404)",
    stroke: "#512D9A",
    strokeWidth: 2.45835
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1.22918,
    x2: 14.4497,
    y2: -1.22918,
    transform: "matrix(0.946056 -0.324004 0.324001 0.946057 544.887 63.7734)",
    stroke: "#512D9A",
    strokeWidth: 2.45835
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M621.775 53.265C596.847 53.0203 576.836 32.6133 577.081 7.68459C577.325 -17.2442 597.732 -37.2545 622.661 -37.0099C647.59 -36.7653 667.6 -16.3583 667.356 8.57047C667.111 33.4992 646.704 53.5096 621.775 53.265Z",
    stroke: "#512D9A",
    strokeWidth: 9.01396
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4031_1049",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 572,
    y: -42,
    width: 100,
    height: 100
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 622.226,
    cy: 8.12637,
    rx: 49.6464,
    ry: 49.6467,
    transform: "rotate(-179.438 622.226 8.12637)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4031_1049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.457 37.8725L602.476 34.7485L539.43 34.1298L588.131 -0.527799L590.799 -2.42651L589.818 -5.55055L571.906 -62.5767L619.915 -26.9701L622.545 -25.0194L625.214 -26.9181L673.913 -61.5757L654.885 -4.91203L653.843 -1.80785L656.473 0.142857L704.483 35.7495L641.439 35.1308L640.396 38.235L621.369 94.8987L603.457 37.8725Z",
    stroke: "#512D9A",
    strokeWidth: 9.01396
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M636.64 3.59424L630.984 20.439L613.216 20.2646L607.891 3.31115L622.368 -6.99162L636.64 3.59424Z",
    fill: "#512D9A",
    stroke: "#512D9A",
    strokeWidth: 9.01396
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M605.273 49.3331L586.788 35.7051L602.302 35.8573L605.273 49.3331Z",
    fill: "#512D9A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M578.247 3.55494L586.627 -17.8271L590.495 -2.80245L578.247 3.55494Z",
    fill: "#512D9A"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1.22917,
    x2: 14.4497,
    y2: -1.22917,
    transform: "matrix(0.632325 -0.774703 -0.7747 -0.632329 601.664 32.9092)",
    stroke: "#512D9A",
    strokeWidth: 2.45835
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -1.22917,
    x2: 14.4497,
    y2: -1.22917,
    transform: "matrix(-0.939515 -0.342507 -0.342504 0.939516 604.215 3.59863)",
    stroke: "#512D9A",
    strokeWidth: 2.45835
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M628.427 164.085C603.499 163.841 583.488 143.434 583.733 118.505C583.978 93.5761 604.385 73.5658 629.313 73.8104C654.242 74.055 674.253 94.462 674.008 119.391C673.763 144.319 653.356 164.33 628.427 164.085Z",
    stroke: "#512D9A",
    strokeWidth: 9.01396
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4031_1049",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 579,
    y: 69,
    width: 100,
    height: 100
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 628.87,
    cy: 118.948,
    rx: 49.6464,
    ry: 49.6467,
    transform: "rotate(-179.438 628.87 118.948)",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4031_1049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.101 148.694L609.12 145.57L546.074 144.951L594.775 110.293L597.443 108.395L596.462 105.271L578.55 48.2446L626.56 83.8512L629.19 85.8019L631.858 83.9032L680.558 49.2456L661.529 105.909L660.487 109.013L663.118 110.964L711.128 146.571L648.083 145.952L647.041 149.056L628.013 205.72L610.101 148.694Z",
    stroke: "#512D9A",
    strokeWidth: 9.01396
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M643.288 114.414L637.633 131.258L619.865 131.084L614.54 114.13L629.017 103.828L643.288 114.414Z",
    fill: "#512D9A",
    stroke: "#512D9A",
    strokeWidth: 9.01396
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M584.896 114.374L593.275 92.9923L597.143 108.017L584.896 114.374Z",
    fill: "#512D9A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M636.565 74.0657L619.882 79.016L632.095 81.9427L636.565 74.0657Z",
    fill: "#512D9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4031_1049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 622,
    height: 101,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballPlayPass);
export default __webpack_public_path__ + "static/media/football-play-pass.1857899278d44ced606976a0da63cf07.svg";
export { ForwardRef as ReactComponent };